import React, { FC } from 'react';
import { NavLink, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { Nav } from 'reactstrap';
import { PageHeader, PermissionBoundary, UserRoute, UserStateComponent } from '../../../components';
import { useTranslation } from '../../../translations';
import { ContactSettings } from './Contact';
import { ConventionSettings } from './Convention';
import { ConventionListSettings } from './ConventionList';
import { PaymentGatewaySettings } from './ExternalPaymentSettings';
import { FlagSettings } from './FlagsSettings';
import { KioskSettings } from './KioskSettings';
import { RegistrationSettings } from './Registration';
import { TermsSettings } from './Terms';
import { BadgeDesignerSettings } from './badgedesigner/BadgeDesignerSettings';
import { TemplateSettings } from './emailtemplates/TemplateSettings';
import { ExportBlock, ExportSettings, MenuLinkSettings, PlatformInfoSettings } from './';

export const SettingsPage: FC<RouteComponentProps> = ({ match: { path, url } }) => {
  const { ts } = useTranslation();
  return (
    <UserStateComponent>
      <PageHeader>{ts('system_settings')}</PageHeader>
      <Nav tabs>
        <NavLink activeClassName="active" className="nav-link" exact to={url}>
          {ts('convention')}
        </NavLink>
        <NavLink activeClassName="active" className="nav-link" to={`${url}/registration`}>
          {ts('registration')}
        </NavLink>
        <NavLink activeClassName="active" className="nav-link" to={`${url}/terms`}>
          {ts('terms')}
        </NavLink>
        <NavLink activeClassName="active" className="nav-link" to={`${url}/badge`}>
          {ts('badge_designer')}
        </NavLink>
        <PermissionBoundary inline requiredPermissions="registration:update">
          <NavLink activeClassName="active" className="nav-link" to={`${url}/flags`}>
            {ts('registration_flags')}
          </NavLink>
        </PermissionBoundary>
        <NavLink activeClassName="active" className="nav-link" to={`${url}/links`}>
          {ts('links')}
        </NavLink>
        <NavLink activeClassName="active" className="nav-link" to={`${url}/contact`}>
          {ts('contact')}
        </NavLink>
        <PermissionBoundary inline requiredPermissions="system:export">
          <NavLink activeClassName="active" className="nav-link" to={`${url}/export`}>
            {ts('export')}
          </NavLink>
        </PermissionBoundary>
        <NavLink activeClassName="active" className="nav-link" to={`${url}/platform`}>
          {ts('platform_info')}
        </NavLink>
        <PermissionBoundary inline requiredPermissions="system:settings:update">
          <NavLink activeClassName="active" className="nav-link" to={`${url}/conventions`}>
            {ts('conventions')}
          </NavLink>
        </PermissionBoundary>
        <PermissionBoundary inline requiredPermissions="system:settings:update">
          <NavLink activeClassName="active" className="nav-link" to={`${url}/payment-gateways`}>
            {ts('payment_gateways')}
          </NavLink>
        </PermissionBoundary>
        <PermissionBoundary inline requiredPermissions="email:templates">
          <NavLink activeClassName="active" className="nav-link" to={`${url}/templates`}>
            {ts('email_templates')}
          </NavLink>
        </PermissionBoundary>
      </Nav>
      <div style={{ marginTop: '20px' }}>
        <Switch>
          <Route component={ConventionSettings} exact path={path} />
          <Route component={RegistrationSettings} exact path={`${path}/registration`} />
          <Route component={TermsSettings} exact path={`${path}/terms`} />
          <Route component={MenuLinkSettings} exact path={`${path}/links`} />
          <Route component={KioskSettings} exact path={`${path}/kiosk`} />
          <Route component={ContactSettings} exact path={`${path}/contact`} />
          <Route component={ExportSettings} exact path={`${path}/export`} />
          <UserRoute
            component={FlagSettings}
            exact
            path={`${path}/flags`}
            requirePermissions="registration:update"
          />
          <Route component={ExportBlock} exact path={`${path}/export/block`} />
          <UserRoute
            component={BadgeDesignerSettings}
            path={`${path}/badge`}
            requirePermissions="system:badgedesign:read"
          />
          <Route component={PlatformInfoSettings} exact path={`${path}/platform`} />
          <UserRoute
            component={ConventionListSettings}
            exact
            path={`${path}/conventions`}
            requirePermissions="system:settings:update"
          />
          <UserRoute
            component={PaymentGatewaySettings}
            exact
            path={`${path}/payment-gateways`}
            requirePermissions="system:settings:update"
          />
          <UserRoute
            component={TemplateSettings}
            path={`${path}/templates`}
            requirePermissions="email:templates"
          />
        </Switch>
      </div>
    </UserStateComponent>
  );
};
